// import React, { useState, useEffect } from 'react';

// const HorizontalTabs = ({ tabs }) => {
//   const [activeTab, setActiveTab] = useState(0);
//   const [isMobile, setIsMobile] = useState(false);

//   const handleTabChange = (event) => {
//     setActiveTab(parseInt(event.target.value, 10));
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
//     };

//     handleResize(); // Initial check

//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   return (
//     <div className="horizontal-tabs">
//       {isMobile ? (
//         <select value={activeTab} onChange={handleTabChange}>
//           {tabs.map((tab, index) => (
//             <option key={index} value={index}>
//               {tab.title}
//             </option>
//           ))}
//         </select>
//       ) : (
//         <div className="tab-list">
//           <div className='tab-fixed-scroll'>
//           <div className='tab-list-data'>
//           {tabs.map((tab, index) => (
//             <div
//               key={index}
//               className={`tab ${activeTab === index ? 'active' : ''}`}
//               onClick={() => setActiveTab(index)}
//             >
//               {tab.title}
//             </div>
//           ))}
//           </div>
//           <div className='school-detail-box'>
//             <h1>Sanskar School</h1>
//             <h5>The Revival of Tradition</h5>
//             <ul>
//               <li>117-121, Vishwamitra Marg, Hanuman Nagar Ext., Sirsi Road, Jaipur - 302012</li>
//               <li>info@sanskarjaipur.com</li>
//               <li> +91-0141-2246189 / +91-0141-2357844 / +91-0141-2245602</li>

//             </ul>



//             </div>
//             </div>
//         </div>
//       )}
//       <div  className="tab-content">
//         {tabs[activeTab].content()}
//       </div>
//     </div>
//   );
// };

// export default HorizontalTabs;


import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const HorizontalTabs = ({ tabs }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract tab index from URL
  const getActiveTabFromURL = () => {
    const params = new URLSearchParams(location.search);
    const tabName = params.get("tab");
    const tabIndex = tabs.findIndex(tab => tab.title === tabName);
    return tabIndex !== -1 ? tabIndex : 0; // Default to first tab if not found
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromURL());
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Sync active tab with URL when it changes
    const params = new URLSearchParams(location.search);
    const tabName = params.get("tab");
    const tabIndex = tabs.findIndex(tab => tab.title === tabName);
    if (tabIndex !== -1 && tabIndex !== activeTab) {
      setActiveTab(tabIndex);
    }
  }, [location.search, tabs]);

  const handleTabChange = (index) => {
    setActiveTab(index);
    navigate(`?tab=${encodeURIComponent(tabs[index].title)}`, { replace: true });
    // 🔥 Scroll to top when tab changes
    window.scrollTo(0, 0);

  
  };
  

  return (
    <div className="horizontal-tabs">
      {isMobile ? (
        <select value={activeTab} onChange={(e) => handleTabChange(parseInt(e.target.value, 10))}>
          {tabs.map((tab, index) => (
            <option key={index} value={index}>
              {tab.title}
            </option>
          ))}
        </select>
      ) : (
        <div className="tab-list">
          <div className="tab-fixed-scroll">
            <div className="tab-list-data">
              {tabs.map((tab, index) => (
                <div
                  key={index}
                  className={`tab ${activeTab === index ? 'active' : ''}`}
                  onClick={() => handleTabChange(index)}
                >
                  {tab.title}
                </div>
              ))}
            </div>
            <div className="school-detail-box">
              <h1>Sanskar School</h1>
              {/* <h5>The Revival of Tradition</h5> */}
              <ul>
                <li>117-121, Vishwamitra Marg, Hanuman Nagar Ext., Sirsi Road, Jaipur - 302012</li>
                <li>info@sanskarjaipur.com</li>
                <li>+91-9928170470 / +91-9001797053 / +91-0141-2245602 (Fax)</li>
              </ul>
            </div>
          </div>
        </div>
      )}
      <div className="tab-content">
        {tabs[activeTab].content()}
      </div>
    </div>
  );
};

export default HorizontalTabs;

// HorizontalTabs.jsx



// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';

// const HorizontalTabs = ({ tabs, activeTabIndex, onTabChange }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   // helper: get tab index from URL param "tab"
//   const getActiveTabFromURL = () => {
//     const params = new URLSearchParams(location.search);
//     const tabName = params.get('tab');
//     const idx = tabs.findIndex(t => t.title === tabName);
//     return idx !== -1 ? idx : 0;
//   };

//   // Controlled if parent passed activeTabIndex (number)
//   const isControlled = typeof activeTabIndex === 'number';

//   // internal state only used when uncontrolled
//   const [internalActive, setInternalActive] = useState(getActiveTabFromURL());
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   // computed active index (source of truth)
//   const active = isControlled ? activeTabIndex : internalActive;

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // sync internalActive when URL changes (only in uncontrolled mode)
//   useEffect(() => {
//     if (!isControlled) {
//       const urlIdx = getActiveTabFromURL();
//       if (urlIdx !== internalActive) setInternalActive(urlIdx);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [location.search, tabs]);

//   // If parent changed controlled value, optionally update URL to reflect it
//   useEffect(() => {
//     if (isControlled) {
//       const params = new URLSearchParams(location.search);
//       const currentName = params.get('tab');
//       const expectedName = tabs[activeTabIndex]?.title ?? tabs[0]?.title;
//       if (expectedName && currentName !== expectedName) {
//         navigate(`?tab=${encodeURIComponent(expectedName)}`, { replace: true });
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [activeTabIndex, isControlled, tabs]);

//   const handleTabChange = (index) => {
//     // update internal if uncontrolled
//     if (!isControlled) setInternalActive(index);

//     // notify parent if provided
//     if (typeof onTabChange === 'function') onTabChange(index);

//     // update URL if needed (avoid unnecessary replace)
//     const desired = tabs[index]?.title;
//     const params = new URLSearchParams(location.search);
//     const current = params.get('tab');
//     if (desired && current !== desired) {
//       navigate(`?tab=${encodeURIComponent(desired)}`, { replace: true });
//     }

//     // optional UX: scroll to top when changing tabs
//     window.scrollTo(0, 0);
//   };

//   return (
//     <div className="horizontal-tabs">
//       {isMobile ? (
//         <select value={active} onChange={(e) => handleTabChange(parseInt(e.target.value, 10))}>
//           {tabs.map((tab, index) => (
//             <option key={index} value={index}>
//               {tab.title}
//             </option>
//           ))}
//         </select>
//       ) : (
//         <div className="tab-list">
//           <div className="tab-fixed-scroll">
//             <div className="tab-list-data">
//               {tabs.map((tab, index) => (
//                 <div
//                   key={index}
//                   className={`tab ${active === index ? 'active' : ''}`}
//                   onClick={() => handleTabChange(index)}
//                 >
//                   {tab.title}
//                 </div>
//               ))}
//             </div>
//             <div className="school-detail-box">
//               <h1>Sanskar School</h1>
//               <ul>
//                 <li>117-121, Vishwamitra Marg, Hanuman Nagar Ext., Sirsi Road, Jaipur - 302012</li>
//                 <li>info@sanskarjaipur.com</li>
//                 <li>+91-9928170470 / +91-9001797053 / +91-0141-2245602 (Fax)</li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="tab-content">
//         {tabs[active]?.content ? tabs[active].content() : null}
//       </div>
//     </div>
//   );
// };

// export default HorizontalTabs;
